import { faFolder, faFile, faFolders } from "@fortawesome/pro-regular-svg-icons";
import {
  faFolder as faFolderSolid,
  faFolders as faFoldersSolid,
} from "@fortawesome/pro-solid-svg-icons";

const ICONS_OPEN = { 1: faFoldersSolid, 2: faFolderSolid };
const ICONS_CLOSED = { 1: faFolders, 2: faFolder };

/**
 * Resolve an asset's icon from its type — the single source shared by the admin
 * knowledge-assets tree and the client asset pages, so both render identically.
 * type 1 = area (double folder), type 2 = process (single folder); anything else
 * falls back to a file. Solid variants are used for the open/expanded state.
 */
export function getNodeIcon(nodeType, isOpen = false) {
  const map = isOpen ? ICONS_OPEN : ICONS_CLOSED;
  return map[nodeType] || faFile;
}
